import { buildAvantisMarkets } from "./avantis";
import { buildSynthetixMarkets } from "./synthetix";
import type { PerpsProtocolConfig, PerpsProtocolId } from "./types";

type ResolvePerpsProtocolConfigParams = {
  protocolRaw: string;
  collateralSynthMarketId: string;
  collateralTokenAddress: string;
};

export function resolvePerpsProtocolConfig({
  protocolRaw,
  collateralSynthMarketId,
  collateralTokenAddress,
}: ResolvePerpsProtocolConfigParams): PerpsProtocolConfig {
  const normalized = (protocolRaw || "").trim().toLowerCase();
  const protocol: PerpsProtocolId =
    normalized === "synthetix" ? "synthetix" : "avantis";

  if (protocol === "synthetix") {
    return {
      id: "synthetix",
      markets: buildSynthetixMarkets({
        collateralSynthMarketId,
        collateralTokenAddress,
      }),
    };
  }

  return {
    id: "avantis",
    markets: buildAvantisMarkets({
      collateralSynthMarketId,
      collateralTokenAddress,
    }),
  };
}

export type {
  PerpsMarket,
  PerpsProtocolConfig,
  PerpsProtocolId,
} from "./types";
